import { render, staticRenderFns } from "./PuzzlePieceIcon.vue?vue&type=template&id=344a6b0e&"
import script from "./PuzzlePieceIcon.vue?vue&type=script&lang=js&"
export * from "./PuzzlePieceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports